import { apiFetch } from './client.js'

export function login(googleToken) {
  return apiFetch('/auth/login', {
    method: 'POST',
    body: { token: googleToken },
  })
}

export function refreshToken() {
  return apiFetch('/auth/refresh', { method: 'POST' })
}

export function fetchMe() {
  return apiFetch('/auth/me')
}

export function logout() {
  return apiFetch('/auth/logout', { method: 'POST' })
}
